/** Цены приходят строками вида "121000.00" или "121 000" */
export function parsePrice(price: string | number): number {
    return Number(String(price).replaceAll(/\s|&nbsp;/g, ""));
}

/** Формат цены как в v2: "121 000" */
export function formatPrice(price: number): string {
    return price.toLocaleString("ru-RU");
}
